import { apiGlobal } from './index'
import { LOCAL_STORAGE } from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const vocabularyEndPoints = {
  SPEECH_CHECK: 'iesv/api/v1/check/speech',
  GET_VOCABULARY_SETS: 'iesv/api/v1/vocabulary-study/topics', // Lấy list vocab sets
  GET_DETAIL_VOCABULARY: 'iesv/api/v1/vocabulary-study/vocabulary-sets', // Lấy chi tiết các vocab set
  GET_VOCABULARY_SUMMARIES: 'iesv/api/v1/vocabulary-study/vocabulary-sets', // Lấy tổng kết các từ vừa học
  GET_VOCABULARY_OVERVIEW: 'iesv/api/v1/vocabulary-study/vocabulary-sets', // Lấy tổng quan các từ cần học
  SAVE_VOCABULARY: 'iesv/api/v1/vocabulary-study/users/vocabularies', // Lưu tiến trình học cụm
  SAVE_ALL_VOCABULARY:
    'iesv/api/v1/knowledge-notebooks/knowledge-buckets/sets/phrases', // Lưu tất cả cụm từ
}

const vocabularyRequest = {
  getSpeechCheck: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        vocabularyEndPoints.SPEECH_CHECK,
        params,
        {},
        true,
      )
    }
    return apiGlobal.post(vocabularyEndPoints.SPEECH_CHECK, params, {}, true)
  },
  getVocabularySets: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${vocabularyEndPoints.GET_VOCABULARY_SETS}`,
        {},
      )
    }
    return apiGlobal.get(
      `${vocabularyEndPoints.GET_VOCABULARY_SETS}`,
      {},
    )
  },
  getDetailVocabulary: (setId: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${vocabularyEndPoints.GET_DETAIL_VOCABULARY}/${setId}/vocabularies/questions`,
        {},
      )
    }
    return apiGlobal.get(
      `${vocabularyEndPoints.GET_DETAIL_VOCABULARY}/${setId}/vocabularies/questions`,
      {},
    )
  },
  getVocabularySummaries: (setId: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${vocabularyEndPoints.GET_VOCABULARY_SUMMARIES}/${setId}/summaries`,
        {},
      )
    }
    return apiGlobal.get(
      `${vocabularyEndPoints.GET_VOCABULARY_SUMMARIES}/${setId}/summaries`,
      {},
    )
  },
  getVocabularyOverview: (setId: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${vocabularyEndPoints.GET_VOCABULARY_OVERVIEW}/${setId}/vocabularies/overviews`,
        {},
      )
    }
    return apiGlobal.get(
      `${vocabularyEndPoints.GET_VOCABULARY_OVERVIEW}/${setId}/vocabularies/overviews`,
      {},
    )
  },
  saveVocabularies: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(vocabularyEndPoints.SAVE_VOCABULARY, params, {})
    }
    return apiGlobal.post(vocabularyEndPoints.SAVE_VOCABULARY, params, {})
  },
  saveAllVocabularies: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        vocabularyEndPoints.SAVE_ALL_VOCABULARY,
        params,
        {},
      )
    }
    return apiGlobal.post(vocabularyEndPoints.SAVE_ALL_VOCABULARY, params, {})
  },
}

export default vocabularyRequest
